import {makeStyles} from "@material-ui/core"
import {ModernTheme} from "../../../../../theme/modern/tokens"

/** Exported so the layer can hold the guides at this thickness while zoomed. */
export const GUIDE_PX = 1.5;

/** Ported from the prototype's `ecg/ecg.css` `.caliper-layer` block. */
export default makeStyles((theme: ModernTheme) => ({
    layer: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        cursor: "crosshair",
        zIndex: 5,
        // the guide lines are moved by direct style writes, so they must not
        // inherit any transition that would lag a drag
        transition: "none",
        /**
         * Hand every gesture on this box to the pointer handlers.
         *
         * Without this a finger drag is claimed by the enclosing `.stage`
         * (`overflow:auto`) and pans the trace instead of measuring it, which is
         * why the calipers did nothing at all on an iPad. Scoped deliberately to
         * the layer and no further: the layer is only mounted while caliper mode
         * is on, so panning the ECG and pinch-zooming the page are untouched the
         * rest of the time.
         */
        touchAction: "none",
        // a drag that starts on the trace must not select the readout tag or
        // pop iOS's long-press callout half way through a measurement
        userSelect: "none",
        WebkitUserSelect: "none",
        WebkitTouchCallout: "none",
    },
    vline: {
        position: "absolute",
        top: 0,
        bottom: 0,
        width: 0,
        borderLeft: `${GUIDE_PX}px solid ${theme.modern.caliper}`,
        pointerEvents: "none",

        "&[hidden]": {display: "none"},
    },
    hline: {
        position: "absolute",
        left: 0,
        right: 0,
        height: 0,
        borderTop: `${GUIDE_PX}px solid ${theme.modern.caliper}`,
        pointerEvents: "none",

        "&[hidden]": {display: "none"},
    },
    tag: {
        position: "absolute",
        transform: "translate(-50%,0)",
        background: theme.modern.caliper,
        color: theme.modern.onAccent,
        font: `600 10.5px ${theme.modern.mono}`,
        padding: "3px 8px",
        borderRadius: 5,
        whiteSpace: "nowrap",
        pointerEvents: "none",
        boxShadow: theme.modern.shadow,
        zIndex: 6,

        "&[hidden]": {display: "none"},
    },
}))
